import React, { useState, useEffect } from "react";
import "../css/blocked.css";
import aang from "../images/aang.jpg";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faAngleRight,
  faArrowLeftLong,
} from "@fortawesome/free-solid-svg-icons";
import No_Blocked_Users from "../no_blocked/No_Blocked_Users";
import { FaSearch } from "react-icons/fa";
import { ClipLoader } from "react-spinners";
import PageCounter from "../../component/page_counter";
import {
  ClassNameDeterminer,
  NameTrimer,
  TypeDeterminer,
} from "../../component/content_trimer";

export default function Blocked_Users() {
  const [data, setData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [result, setResult] = useState();
  const token = JSON.parse(sessionStorage.getItem("userToken"));
  const [searchString, setSearchString] = useState("");
  const [pageCount, setPageCount] = React.useState(1);
  const [disable, setDisable] = useState(false);
  const [disable1, setDisable1] = useState(false);
  const [disable3, setDisable3] = useState(false);
  const [search, setSearch] = useState(false);
  const [resultPerPage, setResultPerPage] = useState(20);

  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, [isLoaded === false]);

  const minusPagec = () => {
    if (pageCount <= 1) {
      return;
    } else {
      setDisable(true);
      const pageCountM = pageCount - 1;
      setPageCount((prev) => prev - 1);
      if (search) {
        fetchSearchData(pageCountM);
      } else {
        fetchData(pageCountM);
      }
    }
  };
  const addPagec = () => {
    if (data?.length <= resultPerPage - 1) return data;
    setDisable1(true);
    const pageCountM = pageCount + 1;
    setPageCount((prev) => prev + 1);
    if (search) {
      fetchSearchData(pageCountM);
    } else {
      fetchData(pageCountM);
    }
  };
  const DataChecker = (data) => {
    if (data) {
      return data;
    } else {
      return "No Data Yet";
    }
  };
  const handleButtonClick = (e) => {
    e.preventDefault();
    setIsLoaded(false);
    setPageCount(1);
    setDisable3(true);
  };

  const fetchData = async (pageCountM) => {
    try {
      setSearch(false);
      const response = await fetch(
        "https://serverpickload.wl.r.appspot.com/view_ops/blocked_users",
        {
          method: "POST",

          body: JSON.stringify({
            token: token,
            pageCount: pageCountM || pageCount,
            resultPerPage: resultPerPage,
          }),
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json, text/plain, */*",
          },
        }
      );
      // setData(await response.json());
      const resultM = await response.json();
      //console.log(resultM)
      setData(resultM.blocked_users);
      setResult(resultM);
      setIsLoaded(true);
      //console.log(resultM);
      //console.log(data);

      if (resultM.msg === "Success") {
        //console.log('data gotten succesfully');
        setDisable(false);
        setDisable1(false);
        setDisable3(false);
      } else if (resultM.msg === "No blocked user found") {
        setData("");
        //console.log('No blocked user found');
      } else {
        setData("");
        //console.log('some error occurred');
      }
    } catch (error) {
      //console.log(error);
    }
  };

  const fetchSearchData = async (pageCountM) => {
    try {
      //console.log(searchString);
      const response = await fetch(
        "https://serverpickload.wl.r.appspot.com/admin_search/blocked_users",
        {
          method: "POST",

          body: JSON.stringify({
            token: token,
            pageCount: pageCountM || pageCount,
            search: searchString,
            resultPerPage: resultPerPage,
          }),
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json, text/plain, */*",
          },
        }
      );

      //console.log('got here');
      // setData(await response.json());
      const result = await response.json();
      setResult(result);
      setData(result.users);
      //console.log(result.users);
      //console.log(data);

      if (result.msg === "Success") {
        //console.log('data gotten succesfully');
        setDisable(false);
        setDisable1(false);
        setDisable3(false);
      } else {
        setData("");
        //console.log('some error occurred');
      }
    } catch (error) {
      //console.log(error);
    }
  };

  if (!isLoaded) {
    //console.log('got here')
    return (
      <h1 className="loading-pages">
        <ClipLoader color={"#1FAA08"} size={100} />
      </h1>
    );
  } else if (data?.length > 0) {
    return (
      <div className="blocked">
        <div className="back1">
          <FontAwesomeIcon
            icon={faArrowLeftLong}
            onClick={() => navigate("/App/Users")}
            className="back"
          ></FontAwesomeIcon>
        </div>
        <div className="blocked-properties">
          <h1 className="blocked-title">Blocked Users</h1>
          <div className="blocked-header">
            <div className="blocked-search-box-container">
              <input
                type="text"
                placeholder="Search Users"
                className="blocked-search-box"
                value={searchString}
                onChange={(e) => setSearchString(e.target.value)}
              />
              <button className="blocked-searching">
                <FaSearch
                  onClick={() => {
                    fetchSearchData();
                    setSearch(true);
                    setPageCount(1);
                  }}
                />
              </button>
            </div>
          </div>
          <div className="result-per-page">
            <form>
              Results per page
              <input
                className="chizys-input"
                type="number"
                value={resultPerPage}
                onChange={(e) => setResultPerPage(e.target.value)}
              />
              <button
                className="chizys-button"
                disabled={disable3}
                onClick={handleButtonClick}
              >
                Done
              </button>
            </form>
          </div>
          <table className="users-table">
            <th>
              <div className="agent-table-left">Picture</div>
            </th>
            <th>Full name</th>
            <th>Email address</th>
            <th>Phone number</th>
            <tbody>
              {data.map((item, i) => (
                <tr key={i}>
                  <td>
                    <div className="users-table-pic">
                      <img
                        src={item?.img ? item?.img : aang}
                        alt=""
                        className="users-table-pic"
                      />
                    </div>{" "}
                  </td>
                  <td className={ClassNameDeterminer(item?.fullname)}>
                    {NameTrimer(DataChecker(item?.fullname))}
                    <p style={{ display: "none" }}>
                      {DataChecker(item?.fullname)}
                    </p>
                  </td>
                  <td>{item?.email}</td>
                  <td>{item?.phone_no}</td>
                  <td>
                    <button
                      className="unblock"
                      onClick={() =>
                        navigate("/App/Unblock_User", {
                          state: { details: item },
                        })
                      }
                    >
                      Unblock
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div
          style={{
            height: "20px",
            display: "flex",
            alignContent: "center",
            justifyContent: "flex-end",
            paddingRight: "20px",
            marginTop: "10px",
          }}
        >
          <div>
            {disable ? (
              <ClipLoader color={"black"} loading={disable} size={15} />
            ) : (
              <FontAwesomeIcon
                icon={faAngleLeft}
                className={pageCount <= 1 ? "icon-space-less" : "icon-space"}
                onClick={minusPagec}
              />
            )}
          </div>
          <h6>{PageCounter(result.count, pageCount, resultPerPage)}</h6>
          <div>
            {disable1 ? (
              <ClipLoader color={"black"} loading={disable1} size={15} />
            ) : (
              <FontAwesomeIcon
                icon={faAngleRight}
                className={
                  data?.length <= resultPerPage - 1
                    ? "icon-space-less"
                    : "icon-space"
                }
                onClick={addPagec}
              />
            )}
          </div>
        </div>
      </div>
    );
  } else if (data?.length === 0) {
    //console.log('and here');
    return <No_Blocked_Users />;
  }
}
